import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';
import { level1Content } from '../../styles/shareableStyles';

export const Container = styled.div<{
  $noMarginTop?: boolean;
  $noMarginBottom?: boolean;
}>`
  /* KB-7610 add extra margin below table to display anchors*/
  margin-top: ${({ $noMarginTop }) => ($noMarginTop ? 0 : '16px')};
  margin-bottom: ${({ $noMarginBottom }) => ($noMarginBottom ? 0 : '124px')};
  min-width: fit-content;
  ${level1Content};

  > :last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  a {
    color: ${theme.colors.secondary800};
    :hover {
      color: ${theme.colors.mainBlue};
    }
  }
`;

export const Row = styled.div<{
  $isHighlighted?: boolean;
  $isHeader?: boolean;
  $gridTemplateColumns?: string;
  $isDisabled?: boolean;
}>`
  position: relative;
  display: grid;
  grid-column-gap: 24px;
  align-items: center;
  min-height: 48px;
  padding: 6px 24px;
  color: ${({ $isDisabled }) =>
    $isDisabled ? theme.colors.secondary400 : theme.colors.secondary800};

  &:nth-child(even) {
    background-color: ${theme.colors.level2};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.border};
  }
  ${({ $isHighlighted }) =>
    $isHighlighted &&
    `
    background-color: ${theme.colors.contentHighlight} !important;
  `}
  ${({ $gridTemplateColumns }) =>
    $gridTemplateColumns &&
    `
   grid-template-columns: ${$gridTemplateColumns};
  `}

  ${({ $isHeader }) =>
    $isHeader &&
    css`
      min-height: 48px;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      background-color: ${theme.colors.tableHeader};
    `}
`;

interface IDataLabel {
  $isBold?: boolean;
  $isDisabled?: boolean;
  $isRightAligned?: boolean;
  $isClickable?: boolean;
}

export const DataLabel = styled.div<IDataLabel>`
  font-size: 12px;
  font-weight: ${({ $isBold }) => ($isBold ? 600 : 'inherit')};
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  color: ${({ $isDisabled }) =>
    $isDisabled ? theme.colors.secondary400 : 'inherit'};
  ${({ $isRightAligned }) =>
    $isRightAligned &&
    css`
      text-align: right;
    `}
`;

export const OverflowingTextWrapper = styled.div<{
  $isRightAligned?: boolean;
  $isBold?: boolean;
  $isDisabled?: boolean;
  $isClickable?: boolean;
}>`
  word-break: break-word;
  width: fit-content;
  color: ${({ $isDisabled }) =>
    $isDisabled ? theme.colors.secondary400 : 'inherit'};

  ${({ $isRightAligned }) =>
    $isRightAligned &&
    `
    margin-left: auto;
  `};

  ${({ $isBold }) =>
    $isBold &&
    `
    font-weight: 600;
  `};

  a {
    color: inherit;

    &:hover {
      color: ${theme.colors.mainBlue};
    }
  }

  ${({ $isClickable }) =>
    $isClickable &&
    css`
      cursor: pointer;

      &:hover {
        color: ${theme.colors.mainBlue};
      }
    `};
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: ${theme.colors.secondary600};
`;

export const RenamedItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 4px;
`;

export const IconWithItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const CheckItemGroup = styled.div`
  display: flex;
  flex-wrap: nowrap;
  column-gap: 8px;
  align-items: center;
`;
